/** @file reportEvents: one host report per fired event with its node, mode and world position. */
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';
import type { PoseBuffer, PoseParams } from '@zilo/pose3d-pose/contract';
import { eventWorldPoint } from '@zilo/pose3d-pose/events/eventWorldPoint';
import type { EventReport, FiredEvent } from '@zilo/pose3d-pose/events/eventTypes';
import type { Rig } from '@zilo/pose3d-pose/rig/rigTypes';

/**
 * Appends a report per fired event in order (17.9, decision 21): node = the event's or the root, mode defaults to
 * `fixed` for step/hook and `null` for hit/sound/custom, world = `eventWorldPoint`, payload passed through.
 */
export function reportEvents(fired: FiredEvent[], pose: PoseBuffer, rig: Rig, params: PoseParams, entityPos: Vec3, out: EventReport[]): EventReport[] {
  for (const { frame, raw, event } of fired) {
    const planting = event.type === 'step' || event.type.startsWith('hook');
    const report: EventReport = {
      type: event.type, node: event.node ?? rig.names[0] ?? '', mode: event.mode ?? (planting ? 'fixed' : null), frame, raw,
      world: eventWorldPoint(pose, rig, event.node, event.pos, params, entityPos),
    };
    out.push(event.payload === undefined ? report : { ...report, payload: event.payload });
  }
  return out;
}
